<template>
  <div>
    <ul style="width: 180px" class="navigation-menu" :style="{'--menu-icon-color': btnColor}">
      <li class="home-link">
        <router-link :to="$store.state.navigationMenuHomeRoute" :class="{active: $route.name === 'MarketplacePage'}" exact-active-class="active">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path
                d="M275.239-604.152v-247.37q0-15.08 11.071-25.898 11.071-10.819 26.523-10.819t26.147 10.819q10.694
                10.818 10.694 25.898v247.37h58.63v-247.37q0-15.582 11.147-26.15 11.147-10.567 26.623-10.567 15.812 0 26.478
                10.567 10.666 10.568 10.666 26.15v247.1q0 62.422-39.533 107.379-39.533 44.956-94.011 57v333.369q0 16.055-10.838
                26.886-10.839 10.831-26.22 10.831-15.381 0-26.379-10.83-10.998-10.832-10.998-26.887v-333.369q-54.478-12.044-93.891-57Q141.935-542 141.935-604.422v-247.1q0-15.582
                11.146-26.15 11.147-10.567 26.552-10.567 15.741 0 26.358 10.567 10.618 10.568 10.618 26.15v247.37h58.63ZM707.544-391h-81.218q-16.85 0-28.12-11.271-11.271-11.27-11.271-27.881v-274.74q0-73.83
                46.141-128.588 46.142-54.759 106.918-54.759 17.95 0 30.087 12.115 12.137 12.114 12.137 29.994v739.456q0 16.055-10.887 26.886t-26.339 10.831q-15.452 0-26.45-10.83-10.998-10.832-10.998-26.887V-391Z"
            />
          </svg>
        </router-link>
      </li>
      <li class="order-link">
        <a v-if="orderProductsCount" @click.prevent="goToOrdersPage" :class="{active: $route.name === 'OrderPage' }">
          <span class="badge" v-if="orderProductsCount">{{ orderProductsCount }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path d="m704-139 139-138-42-42-97 95-39-39-42 43 81 81ZM240-620h480v-60H240v60ZM732.5-41Q655-41 600-96.5T545-228q0-78.435 54.99-133.717Q654.98-417 733-417q77 0 132.5 55.283Q921-306.435 921-228q0 76-55.5 131.5T732.5-41ZM120-81v-699q0-24.75 17.625-42.375T180-840h600q24.75 0 42.375 17.625T840-780v327q-14.169-6.857-29.085-11.429Q796-469 780-472v-308H180v599h310q2.885 18.172 8.942 34.586Q505-130 513-114l-33 33-60-60-60 60-60-60-60 60-60-60-60 60Zm120-199h252.272q3.728-16 8.228-31t12.5-29H240v60Zm0-170h384q22-11 46-17.5t50-8.5v-34H240v60Zm-60 269v-599 599Z"/>
          </svg>
        </a>
        <div v-else>
          <a href="#" @click.prevent="cartOrOrder" :class="{active: $route.name === 'OrderPage' }">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
              <path d="m704-139 139-138-42-42-97 95-39-39-42 43 81 81ZM240-620h480v-60H240v60ZM732.5-41Q655-41 600-96.5T545-228q0-78.435 54.99-133.717Q654.98-417 733-417q77 0 132.5 55.283Q921-306.435 921-228q0 76-55.5 131.5T732.5-41ZM120-81v-699q0-24.75 17.625-42.375T180-840h600q24.75 0 42.375 17.625T840-780v327q-14.169-6.857-29.085-11.429Q796-469 780-472v-308H180v599h310q2.885 18.172 8.942 34.586Q505-130 513-114l-33 33-60-60-60 60-60-60-60 60-60-60-60 60Zm120-199h252.272q3.728-16 8.228-31t12.5-29H240v60Zm0-170h384q22-11 46-17.5t50-8.5v-34H240v60Zm-60 269v-599 599Z"/>
            </svg>
          </a>
        </div>
      </li>
      <li v-show="false" v-if="!isOrderPage && canReserve" class="book-link">
        <router-link :to="{name: 'BookTable', params: { storeId }}" exact-active-class="active">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M383.476-412.544h166.046q14.217 0 23.989-9.478 9.772-9.479 9.772-24.479 0-15.102-9.288-24.453-9.287-9.35-24.99-9.35h-165.6q-15.482 0-24.802 9.519-9.32 9.52-9.32 24.58 0 15.061 9.32 24.361t24.873 9.3Zm-.512-97.76h332.775q14.217 0 23.989-9.479 9.772-9.478 9.772-24.479 0-15.102-9.772-24.452-9.772-9.351-23.989-9.351H382.964q-15.041 0-24.361 9.519-9.32 9.52-9.32 24.581t9.32 24.361q9.32 9.3 24.361 9.3Zm0-97.761h332.775q14.217 0 23.989-9.479 9.772-9.478 9.772-24.479 0-15.102-9.772-24.452-9.772-9.351-23.989-9.351H382.964q-15.041 0-24.361 9.519-9.32 9.52-9.32 24.581t9.32 24.361q9.32 9.3 24.361 9.3ZM269.783-187.391q-31.049 0-54.177-23.447t-23.128-53.858v-558.739q0-30.509 23.128-54.026 23.128-23.517 54.177-23.517h558.739q30.509 0 53.907 23.517 23.397 23.517 23.397 54.026v558.739q0 30.411-23.397 53.858-23.398 23.447-53.907 23.447H269.783ZM132.478-50.087q-31.147 0-54.226-23.397-23.078-23.398-23.078-53.907v-597.892q0-15.636 11.136-26.894t27.174-11.258q16.038 0 27.516 11.258 11.478 11.258 11.478 26.894v597.892H729.37q16.06 0 27.606 11.153 11.546 11.154 11.546 27.49t-11.546 27.499Q745.43-50.087 729.37-50.087H132.478Z"/></svg>
        </router-link>
      </li>
      <li v-show="false" class="favourite-link">
        <router-link
            :to="{name: 'FavoritePage'}"
            exact-active-class="active"
        >
          <span v-if="$store.state.favorites.length" class="stock">{{ $store.state.favorites.length }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path d="M479.761-126.326q-14.718 0-28.435-4.739-13.717-4.739-24.435-15.457l-58.087-54.326q-122.478-113-214.239-218.858-91.76-105.859-91.76-226.098 0-96.718 65.238-161.935 65.24-65.218 160.957-65.218 53.043 0 102.804 24.663 49.761 24.664 87.957 74.381 43.196-49.717 89.956-74.381 46.761-24.663 100.805-24.663 95.956 0 161.435 65.218 65.478 65.217 65.478 161.935 0 120.239-92.62 226.217-92.619 105.978-212.337 218.217l-59.608 54.848q-10.718 10.718-24.555 15.457-13.837 4.739-28.554 4.739Z"/>
          </svg>
        </router-link>
      </li>
      <li v-show="false" v-if="!isOrderPage && storeId" class="money-link">
        <router-link
            :to="{name: 'StoreViewPay', params: { storeId } }"
            exact-active-class="active"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path d="M180.109-102.804q-30.288 0-53.796-23.328-23.509-23.327-23.509-53.977v-599.782q0-30.386 23.509-53.965 23.508-23.579 53.796-23.579h599.782q30.749 0 54.146 23.579 23.398 23.579 23.398 53.965v54H533.63q-54.239 0-91.619 36.394-37.381 36.394-37.381 90.367v239.5q0 54.239 37.381 90.38 37.38 36.141 91.619 36.141h323.805v53q0 30.913-23.398 54.109-23.397 23.196-54.146 23.196H180.109ZM533.63-283.065q-34.993 0-56.898-21.398-21.906-21.398-21.906-55.6v-238.695q0-34.938 21.906-56.057 21.905-21.12 56.898-21.12h286.24q34.754 0 56.659 21.12 21.906 21.119 21.906 56.057v238.695q0 34.202-21.906 55.6-21.905 21.398-56.659 21.398H533.63ZM652.761-416q24.761 0 44.38-19.5 19.62-19.5 19.62-45.5 0-25-19.62-44-19.619-19-44.38-19-25 0-44.5 19t-19.5 44q0 26 19.5 45.5t44.5 19.5Z"/>
          </svg>
        </router-link>
      </li>
      <li v-show="false" class="qr-link">
        <a @click.prevent="qr" :class="isOnMobile ? '' : 'cursor-not-allowed'">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path d="M101.465-701.565q-16.336 0-27.498-11.103-11.163-11.104-11.163-28.049v-118.326q0-15.971 11.104-27.181 11.103-11.211 28.049-11.211h118.326q15.97 0 27.061 11.274 11.091 11.273 11.091 27.609 0 16.097-11.091 27.379t-27.061 11.282h-80.174v79.174q0 16.945-11.274 28.049-11.273 11.103-27.37 11.103Zm.492 638.76q-16.946 0-28.05-11.103-11.103-11.103-11.103-28.049v-118.326q0-15.97 11.338-27.061t27.674-11.091q16.097 0 27.195 11.091 11.098 11.091 11.098 27.061v80.174h80.174q15.97 0 27.061 11.274 11.091 11.273 11.091 27.37 0 16.336-11.091 27.498-11.091 11.163-27.061 11.163H101.957Zm638.76 0q-16.945 0-28.049-11.337-11.103-11.338-11.103-27.674 0-16.097 11.103-27.195 11.104-11.098 28.049-11.098h79.174v-80.174q0-15.97 11.458-27.061 11.457-11.091 27.554-11.091 16.336 0 27.434 11.091 11.098 11.091 11.098 27.061v118.326q0 16.946-11.211 28.05-11.21 11.103-27.181 11.103H740.717Zm117.835-638.76q-16.097 0-27.379-11.103-11.282-11.104-11.282-28.049v-79.174h-79.174q-16.945 0-28.049-11.458-11.103-11.457-11.103-27.554 0-16.336 11.103-27.434 11.104-11.098 28.049-11.098h118.326q15.971 0 27.181 11.211 11.211 11.21 11.211 27.181v118.326q0 16.945-11.274 28.049-11.273 11.103-27.609 11.103ZM711.565-183.152v-64.283h64.283v64.283h-64.283Zm0-128.805v-64.282h64.283v64.282h-64.283Zm-64.522 64.522v-64.522h64.522v64.522h-64.522Zm-64.282 64.283v-64.283h64.282v64.283h-64.282Zm-64.522-64.283v-64.522h64.522v64.522h-64.522Zm128.804-128.804v-64.522h64.522v64.522h-64.522Zm-64.282 64.282v-64.282h64.282v64.282h-64.282Zm-64.522-64.282v-64.522h64.522v64.522h-64.522Zm39.152-143q-16.706 0-27.929-11.223-11.223-11.223-11.223-27.929v-180.305q0-15.97 11.223-27.061t27.929-11.091h180.305q15.97 0 27.061 11.091t11.091 27.061v180.305q0 16.706-11.091 27.929-11.091 11.223-27.061 11.223H557.391ZM222.304-183.152q-16.945 0-28.049-11.103-11.103-11.104-11.103-28.049v-180.305q0-15.731 11.103-26.942 11.104-11.21 28.049-11.21h180.305q15.731 0 26.942 11.21 11.21 11.211 11.21 26.942v180.305q0 16.945-11.21 28.049-11.211 11.103-26.942 11.103H222.304Zm0-336.087q-16.945 0-28.049-11.223-11.103-11.223-11.103-27.929v-180.305q0-15.97 11.103-27.061 11.104-11.091 28.049-11.091h180.305q15.731 0 26.942 11.091 11.21 11.091 11.21 27.061v180.305q0 16.706-11.21 27.929-11.211 11.223-26.942 11.223H222.304Zm19.848 277.087h140.37v-140.37h-140.37v140.37Zm0-335.326h140.37v-140.37h-140.37v140.37Zm334.326 0h140.37v-140.37h-140.37v140.37Z"/>
          </svg>
        </a>
      </li>
      <li v-if="false" class="promo-link">
        <a @click.stop="() => {}" class="cursor-not-allowed">
          <img width="22" src="/svg/navigation/promo-icon.svg" alt=""/>
        </a>
      </li>
      <li class="account-link">
        <router-link
            :to="{ name: 'MenuAccountPage' }"
            exact-active-class="active"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path d="M479.989-488.435q-72.745 0-118.182-45.557T316.37-652.136q0-72.588 45.399-118.074 45.399-45.486 118.144-45.486t118.351 45.459q45.606 45.46 45.606 118.22 0 72.468-45.568 118.025t-118.313 45.557ZM143.326-207.304v-32.976q0-41.985 20.513-72.333 20.514-30.348 53.878-45.691 68.761-32 133.142-47.381 64.38-15.38 129.077-15.38 65.174 0 128.88 16 63.706 16 132.467 46.761 34.428 15.064 55.029 45.432 20.601 30.368 20.601 72.592v32.976q0 32.769-22.379 55.037Q772.154-130 739.37-130H220.63q-32.685 0-54.995-22.267-22.309-22.268-22.309-55.037Z"/>
          </svg>
        </router-link>
      </li>
    </ul>
    <van-popup
        v-model="qrcodeModal"
        position="bottom"
        class="qrscan-modal"
        @closed="closedQrModal"
        closeable
        close-icon-position="top-left"
        :style="{ height: '100%', zIndex: '999999' }"
    >
      <div v-if="!decoded" class="qrscan-modal-content">
        <qrcode-stream
            v-if="!destroyed"
            @init="onInit"
            @decode="onDecode"
            :camera="camera"
            :torch="torchActive"
        >
          <loading-block v-if="loading"/>
          <button class="touch-btn" @click="torchActive = !torchActive" :disabled="torchNotSupported">
            <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
              <path d="m183.935-684.348-38.283-37.282q-11.717-11.598-12.098-26.995-.38-15.397 11.358-27.114 11.458-11.239 27.747-11.359 16.289-.12 28.102 11.359l37.282 36.521q10.718 11.479 10.718 27.435 0 15.957-11.547 27.435-11.82 11.757-27.31 11.237-15.491-.519-25.969-11.237Zm257.674-126.087v-52.282q0-15.927 11.097-27.159 11.098-11.233 28.055-11.233 16.196 0 27.174 11.233 10.978 11.232 10.978 27.159v52.282q0 17.196-10.978 28.294-10.978 11.098-27.174 11.098-16.957 0-28.055-11.098-11.097-11.098-11.097-28.294Zm281.108 72.217 38.522-37.521q11.239-10.718 26.887-10.218t27.222 11.218q11.239 12.478 10.859 27.935-.381 15.456-11.859 26.174l-37.044 38.282q-11.956 11.718-27.658 11.098-15.701-.62-26.45-12.098-11.957-10.717-11.957-27.033 0-16.317 11.478-27.837ZM342.696-134.283V-267.37l-98.087-98.086q-10.718-10.718-17.076-25.494-6.359-14.776-6.359-30.615v-113.131q0-32.784 22.309-55.164 22.309-22.379 54.995-22.379h363.044q32.784 0 55.164 22.379 22.379 22.38 22.379 55.164v113.131q0 15.839-6.478 30.615-6.478 14.776-17.196 25.494l-97.847 98.086v133.087q0 32.686-22.38 54.996Q572.785-56.978 540-56.978H420q-32.686 0-54.995-22.31-22.309-22.309-22.309-54.995Z"/>
            </svg>
          </button>
          <button class="switch-camera" @click="switchCamera">
            <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
              <path d="M315.109-277.87q-31.283 0-51.544-20.88-20.261-20.88-20.261-50.924v-236.043q0-30.044 20.261-51.044 20.261-21 51.544-21h41.608l22.848-23.369q4.761-5.24 11.739-8.479 6.979-3.239 15.457-3.239H557q7.478 0 14.457 3.239 6.978 3.239 13.217 8.479l22.369 23.369h41.848q30.044 0 50.924 21 20.881 21 20.881 51.044v236.043q0 33.848-18.718 52.826-18.717 18.978-53.087 18.978H315.109Zm166.652-132.565q23.761 0 39.761-16 16-16 16-41 0-23.761-16-39.641-16-15.881-39.761-15.881-25 0-40.761 15.881-15.761 15.88-15.761 39.641 0 25 15.761 41t40.761 16Zm-1 421.652q-180.609 0-316.435-112.706Q28.5-214.196-5.5-387.804q-3.239-16 5.62-30.359Q8.978-432.522 25.978-435q15.24-1 27.098 8.12 11.859 9.119 15.098 24.597Q91.934-268.348 200.326-171.5 308.717-74.652 445.413-63.413l-43.609-44.848q-10.761-9.522-10.261-24.522.5-15 11.261-25.761 9.522-10.76 25.022-10.76 15.5 0 26.022 10.521l135.239 135.24q5.761 7 3.38 15.5-2.38 8.5-9.38 9.26-25.522 5.761-51.924 7.88-26.402 2.12-50.402 2.12Zm1.478-983.195q179.609 0 314.935 114.087T965.5-572.435q3.239 17.239-5.5 30.718-8.739 13.478-23.978 15.478-15.479 2.478-27.718-7.261t-15.239-24.978q-24-133.935-132.272-230.783-108.271-96.848-245.206-108.326l44.848 44.848q9.522 10.761 9.522 25.141 0 14.381-9.522 25.142-10.761 11.76-26.261 11.88-15.5.12-26.022-11.641l-135-135q-7-6.239-4.119-14.62 2.88-8.38 10.88-10.38 24.522-5.761 50.544-7.761 26.021-2 51.782-2Z"/>
            </svg>
          </button>
        </qrcode-stream>
        <qrcode-drop-zone></qrcode-drop-zone>
        <qrcode-capture></qrcode-capture>
      </div>
      <iframe v-else height="100%" width="100%" :src="decoded" frameborder="0"></iframe>
    </van-popup>
    <van-popup
        v-model="payTipModal"
        position="bottom"
        class="qrscan-modal"
        @closed="closePayTip"
        closeable
        close-icon-position="top-left"
        :style="{ height: '100%' }"
    >
      <iframe
          height="100%" width="100%"
          :src="payTipUrl"
          frameborder="0"
      >
      </iframe>
    </van-popup>
  </div>
</template>

<script>
import {Notify, Popup} from "vant";
import {QrcodeStream, QrcodeDropZone, QrcodeCapture} from 'vue-qrcode-reader'
import LoadingBlock from "@/components/Loading.vue";
import {mapGetters} from "vuex";
import {useUserAgent} from "@/helpers/useUserAgent";

export default {
  name: "NavigationMenu",
  props: {
    storeId: {
      default: null
    },
  },
  emits: ['cart'],
  components: {
    LoadingBlock,
    "van-popup": Popup,
    // eslint-disable-next-line vue/no-unused-components
    QrcodeStream,
    // eslint-disable-next-line vue/no-unused-components
    QrcodeDropZone,
    // eslint-disable-next-line vue/no-unused-components
    QrcodeCapture,
  },
  data: function () {
    return {
      qrcodeModal: false,
      payTipModal: false,
      payTipUrl: '',
      decoded: false,
      loading: false,
      destroyed: false,
      torchActive: false,
      torchNotSupported: false,
      noRearCamera: false,
      noFrontCamera: false,
      camera: "rear",
      isOnMobile: false,
    }
  },
  methods: {
    handlePayTip() {
      // if (this.storeId)
      //   this.payTipUrl = `https://tips.multicard.uz/p/${this.storeId}`;
      // this.payTipModal = true;
    },
    cartOrOrder() {
      this.$emit('cart', (success) => {
        if (!success) {
          this.goToOrdersPage()
        }
      })
    },
    goToOrdersPage() {
      this.$router.push({
        name: 'OrderPage',
        params: {
          desk: this.desk,
          order: this.$route.params.order ?? null
        }
      })
    },
    closePayTip() {
    },
    changeZIndexStyle(increase) {
      this.$emit('change-zindex', increase)
    },
    async qr(e) {
      if (this.useragent === 'browser') {
        await this.openQrcodeModal(e)
      } else {
        window.flutter_inappwebview.callHandler('scanQr', {
          type: "rhmt"
        }).then(async (res) => {
          if (res)
            if (res.substr(0, 25) === 'https://tips.multicard.uz' || res.substr(0, 19) === 'https://app.rhmt.uz') {
              window.location.href = res;
              // this.decoded = res;
              // await this.$nextTick();
              // this.qrcodeModal = true;
            }
          Notify({
            type: "warning",
            message: "Не удалось распознать QR-код",
          });
        }).catch(() => {
          Notify({
            type: "warning",
            message: "Не удалось распознать QR-код",
          });
        });
      }
    },
    async openQrcodeModal(e) {
      if (!this.isOnMobile) {
        e.stopPropagation();
        return false;
      }
      this.decoded = false;
      this.camera = "rear";
      this.changeZIndexStyle(true);
      await this.$nextTick();
      this.qrcodeModal = true;
    },
    async closedQrModal() {
      this.destroyed = true;
      await this.$nextTick();
      this.destroyed = false;
      this.camera = "off";
      this.changeZIndexStyle(false);
      await this.$nextTick();
      this.qrcodeModal = false;
      this.decoded = false;
    },
    onDecode(decodedString) {
      if (decodedString) {
        this.decoded = decodedString;
        // this.decoded = "https://tips.multicard.uz/p/6?c=a8a013fc-5613-4b0c-87f2-5eefa64300cb&o=13f95058-1d2a-11ed-b1d8-07ce97beca8d&b=A2&a=106810&e=0";
        this.camera = "off";
        // this.qrcodeModal = false;
      } else {
        this.decoded = false;
      }
    },
    async onInit(promise) {
      this.loading = true;

      try {
        const {capabilities} = await promise;
        this.torchNotSupported = !capabilities.torch;
      } catch (error) {
        const triedFrontCamera = this.camera === 'front';
        const triedRearCamera = this.camera === 'rear';

        const cameraMissingError = error.name === 'OverconstrainedError';

        if (triedRearCamera && cameraMissingError) {
          this.noRearCamera = true;
        }

        if (triedFrontCamera && cameraMissingError) {
          this.noFrontCamera = true;
        }
        console.error(error)
      } finally {
        this.loading = false;
      }
    },
    switchCamera() {
      switch (this.camera) {
        case 'front':
          this.camera = 'rear';
          break;
        case 'rear':
          this.camera = 'front';
          break;
      }
    },
    detectDevice() {
      this.isOnMobile = !!(navigator.userAgent.match(/Android/i)
          || navigator.userAgent.match(/webOS/i)
          || navigator.userAgent.match(/iPhone/i)
          || navigator.userAgent.match(/iPad/i)
          || navigator.userAgent.match(/iPod/i)
          || navigator.userAgent.match(/BlackBerry/i)
          || navigator.userAgent.match(/Windows Phone/i)
          || navigator.userAgent.match(/Multicard/i));
    }
  },
  created() {
    this.detectDevice();
  },
  computed: {
    ...mapGetters(['btnColor', 'canReserve', 'order']),
    useragent() {
      return useUserAgent().getUserAgent()
    },
    desk() {
      const menuRoute = this.$store.state.navigationMenuHomeRoute
      return menuRoute.split('/')?.[3] ?? null;
    },
    orderProductsCount() {
      let count = 0
      this.order.forEach(order => {
        if (order.desk === this.desk) {
          count += order?.data?.items?.length ?? 0
        }
      })
      return count;
    },
    icon() {
      if (this.torchActive)
        return '/zap-off.svg'
      else
        return !this.torchNotSupported ? '/flash-sharp.svg' : '/flash-off-sharp.svg'
    },
    isOrderPage() {
      return ['FavoritePage', 'MenuAccountPage', 'MarketplacePage', 'CatalogPage'].some(page => this.$route.name.includes(page));
    }
  }
};
</script>

<style lang="scss" scoped>
.touch-btn,
.switch-camera {
  position: absolute;
  right: 16px;
  top: 16px;
  width: auto;
  height: auto;
  background: transparent;
  border-radius: 5px;
  color: #7C7C7C;
  font-size: 16px !important;
  border: none;

  img {
    //width: 100%;
  }
}

.badge {
  position: absolute;
  background: #ff5b5b;
  color: #fff;
  width: 18px;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  border-radius: 18px;
  top: -2px;
  right: 4px;
  box-shadow: 0 2px 4px #00000040;
}

.switch-camera {
  left: 50%;
  right: unset;
  transform: translateX(-50%);
}

.navigation-menu {
  position: fixed;
  z-index: 4;
  bottom: 20px;
  left: 20px;
  right: 20px;
  height: 50px;
  background: #ffffff;
  display: flex;
  justify-content: space-evenly;
  max-width: 760px;
  margin: 0 auto;
  background: linear-gradient(95.73deg, rgba(255, 255, 255, 0.5) -14.53%, rgba(255, 255, 255, 0.3) 51.05%);
  //box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05), 0px 4px 20px -1px rgba(240, 240, 240, 0.2);
  box-shadow: 0 4px 30px -1px rgba(240, 240, 240, 0.4);
  border: 1px solid rgba(240, 240, 240, 0.4);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  border-radius: 22px;

  li {
    display: block;

    a {
      vertical-align: middle;
      height: 35px;
      display: block;
      background: none;
      width: 50px;
      padding: 5px;
      margin: 6px 0;
      border-radius: 15px;
      transition: all 0.2s ease;
      position: relative;
      text-align: center;

      .stock {
        position: absolute;
        top: 11px;
        right: -9px;
        color: #21201F;
        font-size: 12px;
        background: #FCE000;
        font-weight: bold;
        border-radius: 44px;
        padding: 1px 5px;
      }

      &.cursor-not-allowed {
        cursor: not-allowed;
        opacity: .3;
      }

      &.active {
        opacity: 1;
        filter: none;
        transition: all 0.2s ease;
        background: var(--menu-icon-color);
        //background: linear-gradient(98.41deg, #2FCA96 18.37%, #0FAEAE 80.18%);

        svg, path {
          fill: #ffffff;
          //fill: var(--menu-icon-color);
          //stroke: var(--menu-icon-color);
        }
      }

      img {
        margin: 0 auto;
        display: block;
      }
    }
  }
}
</style>
